import { render } from "./BienTotauxTable.vue?vue&type=template&id=4642370a"
import script from "./BienTotauxTable.vue?vue&type=script&lang=js"
export * from "./BienTotauxTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__